import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react"; // 引入二维码
import zh_CN from "antd/es/locale/zh_CN";
import {
  Table,
  Space,
  message,
  Drawer,
  Tag,
  ConfigProvider,
  Button,
} from "antd";
import BoxServe from "../../../ajax/api/index";
import { DownloadOutlined } from "@ant-design/icons";
import { exportExcel } from "../../../utils/index";

import "./PaiXiang.scss";
import SearchHead from "./components/SearchHead"; // 搜索区域

export default function PaiXiang() {
  const columns = [
    {
      title: "设备号",
      key: "deviceId",
      dataIndex: "deviceId",
      width: 300,
    },
    {
      title: "设备二维码",
      key: "deviceQRCodeUrl",
      dataIndex: "deviceQRCodeUrl",
      width: 130,
      render: (_, record) => (
        <Space size="middle">
          <QRCode
            className="qrcode"
            value={record.deviceQRCodeUrl}
            size={65} // 二维码图片大小（宽高115px）
            bgColor="#fff1d1" // 二维码背景颜色
            fgColor="#c7594a" // 二维码图案颜色
          />
        </Space>
      ),
    },

    {
      title: "在线状态",
      key: "onlineStatus",
      dataIndex: "onlineStatus",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          {record.onlineStatus === "离线" ? (
            <Tag color="#f50">离线</Tag>
          ) : (
            <Tag color="#87d068">在线</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "当前设备状态",
      key: "stateName",
      dataIndex: "stateName",
      width: 100,
    },
    {
      title: "当前任务",
      key: "realTasks",
      dataIndex: "realTasks",
      width: 100,
    },
    {
      title: "接入方式",
      key: "accessTypeName",
      dataIndex: "accessTypeName",
      width: 100,
    },
    {
      title: "带宽资源类型",
      key: "bandWidthTypeName",
      dataIndex: "bandWidthTypeName",
      width: 80,
    },
    {
      title: "绑定时间",
      key: "bindTime",
      dataIndex: "bindTime",
      width: 180,
    },

    {
      title: "城市",
      key: "city",
      dataIndex: "city",
      width: 100,
    },

    {
      title: "cpu数量",
      key: "cpuNum",
      dataIndex: "cpuNum",
      width: 90,
    },

    {
      title: "添加人名称",
      key: "createUserName",
      dataIndex: "createUserName",
      width: 120,
    },
    {
      title: "网络类型",
      key: "diallingTypeName",
      dataIndex: "diallingTypeName",
      width: 120,
    },
    {
      title: "上报带宽(Mbps)",
      key: "upBandwidthSize",
      dataIndex: "upBandwidthSize",
      width: 160,
    },

    {
      title: "磁盘信息",
      key: "diskInfo",
      dataIndex: "diskInfo",
      width: 400,
      render: (_, record) => {
        let contentStr = record.diskInfoList;
        let br = <br></br>;
        let result = null;
        for (let j = 0; j < contentStr.length; j++) {
          result = (
            <span>
              {result}
              名称:{contentStr[j].diskId}&nbsp;&nbsp; 空间大小:{" "}
              {contentStr[j].newDiskSize}
              &nbsp;&nbsp; 类型:{contentStr[j].diskMedia}
              {br}
            </span>
          );
        }
        return <div>{result}</div>;
      },
    },

    {
      title: "运营商",
      key: "isp",
      dataIndex: "isp",
      width: 100,
    },
    {
      title: "内存大小",
      key: "memoryType",
      dataIndex: "memoryType",
      width: 150,
    },

    {
      title: "网络服务稳定性测试结果",
      key: "stabilityTestResultName",
      dataIndex: "stabilityTestResultName",
      width: 250,
    },

    {
      title: "备注",
      key: "remark",
      dataIndex: "remark",
      // ellipsis: true,
      width: 250,
    },

    {
      title: "更新时间",
      key: "updateTime",
      dataIndex: "updateTime",
      width: 180,
    },

    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <span className="action-btn" onClick={() => handleSee(record)}>
            查看
          </span>
        </Space>
      ),
    },
  ];
  // 提示信息
  const [messageApi, contextHolder] = message.useMessage();
  const [searchParams, setSearchParams] = useState({});
  let [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detailObj, setDetailObj] = useState({});
  // 详情抽屉
  const [open, setOpen] = useState(false);
  // 总条数
  const [total, setTotal] = useState(0);

  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    current: 1,
    defaultPageSize: 20,
  });
  // 搜索
  const handleSearch = (obj) => {
    setSearchParams(obj);
    setTableParams({
      ...tableParams,
      current: 1,
      ...obj,
    });
  };

  const [params] = useState({
    page: tableParams.page,
    limit: tableParams.limit,
    current: tableParams.page,
  });

  // 分页等
  const onChange = (pagination) => {
    const { current, pageSize } = pagination;
    setList([]);
    setTableParams({
      ...searchParams,
      page: current,
      limit: pageSize,
      defaultPageSize: 20,
    });
  };

  // 列表数据
  const getList = async (model) => {
    try {
      setLoading(true);
      const { code, data, count } = await BoxServe.getTpxdeviceList(
        tableParams
      ).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        setTotal(count ? Number(count) : 0);
        const list = data?.map((item) => {
          return {
            ...item,
            key: item.id,
            deviceQRCodeUrl: "px86_" + item.deviceId,
            upBandwidthSize: item.upBandwidth
              ? item.upBandwidth / 1024 / 1024
              : "",
            diskInfoList: item.diskInfo
              ? JSON.parse(item.diskInfo)?.map((fitem) => {
                  return {
                    ...fitem,
                    newDiskSize: recursiveDivision(fitem.diskSize),
                  };
                })
              : [] || [],
            cpuFrequencySize: item.cpuFrequency / 1000000000 || "",
          };
        });
        console.log(list);
        setList(list);
      } else {
        messageApi.open({
          type: "warning",
          content: "出错了~",
        });
      }
    } catch (error) {
      // message.error(error.message || error.msg)
      console.log(error);
    }
  };

  // 流量不同数值不同单位算法
  const recursiveDivision = (bytes) => {
    if (bytes === 0) return "0 B";
    let k = 1024,
      sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(2) + " " + sizes[i];
  };

  // 查看
  const handleSee = (record) => {
    setDetailObj(record);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getList();
  }, [tableParams, params]);

  const handleExportExcel = () => {
    const name = `派享x86列表_${new Date().getTime()}`;
    const sheetHeader = [];
    const sheetFilter = [];
    const columnWidths = [];

    // const sheetHeader = ["设备号", "状态", "设备所在地", "运行业务"];
    // let sheetFilter = ["deviceNo", "onlineState", "city", "askBusiness"];
    columns?.forEach((item) => {
      let { title, dataIndex, width } = item;
      if (title !== "操作") {
        sheetHeader.push(title);
      }
      sheetFilter.push(dataIndex);
      columnWidths.push(width / 10);
    });
    exportExcel(list, name, sheetHeader, sheetFilter, columnWidths);
  };

  // 重置
  const handleReset = () => {
    setTableParams({
      page: 1,
      limit: 20,
      current: 1,
      defaultPageSize: 20,
    });
  };

  return (
    <>
      {contextHolder}
      <div className="px-wrap">
        <div className="search-wrap">
          <SearchHead handleSearch={handleSearch} handleReset={handleReset} />
        </div>
        <div className="top">
          <div className="top-left"></div>
          <div className="top-right">
            <Space wrap className="operate-btn">
              <Button
                type="dashed"
                danger
                icon={<DownloadOutlined />}
                onClick={handleExportExcel}
              >
                导出Excel
              </Button>
            </Space>
          </div>
        </div>
        <ConfigProvider locale={zh_CN}>
          <Table
            scroll={{ x: "100%" }}
            filterMultiple
            columns={columns}
            dataSource={list}
            loading={loading}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000, 10000],
              total,
              ...tableParams,
              showTotal: (total) => {
                return `共 ${total} 条`;
              },
            }}
            onChange={onChange}
            className="device-home"
          />
        </ConfigProvider>
        <Drawer
          title={detailObj.deviceId + "----详情"}
          width={1000}
          placement="right"
          onClose={onClose}
          open={open}
          className="drawer-wrap"
        >
          <ul className="content-list">
            <li className="list-item">
              <span className="title">设备号:</span>
              <span className="text">{detailObj.deviceId}</span>
            </li>
            <li className="list-item">
              <span className="title">设备二维码:</span>
              <span className="text">
                <QRCode
                  className="qrcode"
                  value={detailObj.deviceQRCodeUrl}
                  size={100} // 二维码图片大小（宽高115px）
                  bgColor="#fff1d1" // 二维码背景颜色
                  fgColor="#c7594a" // 二维码图案颜色
                />
              </span>
            </li>
            <li className="list-item">
              <span className="title">在线状态:</span>
              <span className="text">{detailObj.onlineStatus || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">当前设备状态:</span>
              <span className="text">{detailObj.stateName || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">当前任务:</span>
              <span className="text">{detailObj.realTasks || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">接入方式:</span>
              <span className="text">{detailObj.accessTypeName || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">带宽资源类型:</span>
              <span className="text">{detailObj.bandWidthTypeName || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">绑定时间:</span>
              <span className="text">{detailObj.bindTime || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">城市:</span>
              <span className="text">{detailObj.city || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">cpu数量:</span>
              <span className="text">{detailObj.cpuNum || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">添加人名称:</span>
              <span className="text">{detailObj.createUserName || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">网络类型:</span>
              <span className="text">{detailObj.diallingTypeName || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">上报带宽(Mbps):</span>
              <span className="text">{detailObj.upBandwidthSize || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">磁盘信息:</span>
              <span className="text">
                <table border="1px">
                  <thead>
                    <tr>
                      <th style={{ padding: "10px" }}>名称</th>
                      <th style={{ padding: "10px" }}>空间大小</th>
                      <th style={{ padding: "10px" }}>类型</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailObj.diskInfoList?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td style={{ padding: "10px" }}>{item.diskId}</td>
                          <td style={{ padding: "10px" }}>
                            {item.newDiskSize}
                          </td>
                          <td style={{ padding: "10px" }}>{item.diskMedia}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </span>
            </li>
            <li className="list-item">
              <span className="title">运营商:</span>
              <span className="text">{detailObj.isp || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">内存大小:</span>
              <span className="text">{detailObj.memoryType || "-"}</span>
            </li>

            <li className="list-item">
              <span className="title">网络服务稳定性测试结果:</span>
              <span className="text">
                {detailObj.stabilityTestResultName || "-"}
              </span>
            </li>

            <li className="list-item">
              <span className="title">备注:</span>
              <span className="text">{detailObj.remark || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">镜像版本:</span>
              <span className="text">{detailObj.imageVersion || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">机房类型:</span>
              <span className="text">{detailObj.machineRoomType || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">cpu核:</span>
              <span className="text">{detailObj.cpuFrequencySize} GHz</span>
            </li>
            <li className="list-item">
              <span className="title">更新人名称:</span>
              <span className="text">{detailObj.updateUserName || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">更新时间:</span>
              <span className="text">{detailObj.updateTime || "-"}</span>
            </li>

            <li className="list-item">
              <span className="title">绑定时间:</span>
              <span className="text">{detailObj.bindTime || "-"}</span>
            </li>
            <li className="list-item">
              <span className="title">操作时间:</span>
              <span className="text">{detailObj.createTime || "-"}</span>
            </li>
          </ul>
        </Drawer>
      </div>
    </>
  );
}
